module.exports = __webpack_public_path__ + "img/main_tnbox_service_04_2.53ebc00d.svg";